export const BASE_AWS_URL = process.env.REACT_APP_CF_URL;

export const UserType = {
  TALENT: 'talent',
  BRAND: 'brand',
  AGENCY: 'agency',
  SCHOOL: 'school',
  FAN: 'fan',
};

export const TalentType = {
  MUSICIAN: 'musician',
  ATHLETE: 'athlete',
  COACH: 'coach',
  INFLUENCER: 'influencer',
  MOTIVATIONAL_SPEAKER: 'motivational-speaker',
};

export const TalentLevel = {
  PROFESSIONAL: 'professional',
  COLLEGIATE: 'collegiate',
  HIGH_SCHOOL: 'high_school',
  RETIRED: 'retired',
};

export const FieldConfigKey = {
  TALENT_TYPE: 'talent_type',
  TALENT_LEVEL: 'talent_level',
  ATHLETE: 'athlete',
  GENDER: 'gender',
  ETHNICITY: 'ethnicity',
  HOMETOWN: 'hometown',
  SHIRT_SIZE: 'shirt_size',
  REFERRED_BY: 'referredBy',
  SCHOOL_OR_TEAM: 'school_or_team',
  POSITION: 'position',
  SPORT: 'sport',
  COMPANY: 'company',
  BIO: 'description',
  SCHOOL_NAME: 'school_name',
  INTEREST: 'interest',
  JOB_TITLE: 'job_title',
  SCHOOL_OR_GROUP_NAME: 'school_or_group_name',
  STATE_OR_TERRITORY: 'state_or_territory',
  USER_TYPE_SCT: 'user_type_sct',
  CONFERENCE: 'conference',
  CURRENT_TOWN: 'current_town',
  HEIGHT: 'height',
  WEIGHT: 'weight',
  JERSEY_NUMBER: 'jersey_number',
  AGENCY_FIELD: 'agency',
  SOCIAL_MEDIA: 'social_media',
  SOCIAL_MEDIA_LINK: 'social_media_link',
  PRIMARY_INDUSTRY: 'primary_industry',
  DATE_OF_BIRTH: 'dateOfBirth',
};

export const FieldTypes = {
  INTEREST: 'interest',
  LIFE_EVENT: 'lifeEvent',
  SOCIAL_MEDIA: 'socialMedia',
  AFFILIATION: 'affiliation',
};

export const DEFAULT_LISTING_CARD_SIZES = [
  '(max-width: 549px) 100vw',
  '(max-width: 767px) 50vw',
  `(max-width: 1439px) 26vw`,
  `(max-width: 1920px) 18vw`,
  `14vw`,
].join(', ');

// Define an enum-like object for talent attributes and freeze it to prevent modifications
export const TalentAttributes = Object.freeze({
  LEVEL: 'level',
  TITLE: 'title',
  BIO: 'description',
  PROFILE_DETAILS: 'profileDetails',
  CREATED_AT: 'createdAt',
});
// Define an enum-like object for School attributes and freeze it to prevent modifications
export const SchoolAttributes = Object.freeze({
  ID: 'id',
  TITLE: 'title',
  SCHOOL_DISPLAYNAME: 'schoolDisplayName',
  LOGO: 'logo',
});

export const ProfileDetails = {
  SOCIAL_MEDIA: 'socialMedia',
};

export const TalentSignupStep = {
  INITIAL: 'initial',
  FINAL: 'final',
};

export const FilterOptionsKeys = {
  ALL: 'all',
  OTHER: 'other',
  MEN: 'mens',
  WOMEN: 'womens',
};
export const SocialMediaPlatform = {
  FACEBOOK: 'facebook',
  INSTAGRAM: 'instagram',
  TWITTER: 'twitter',
  LINKEDIN: 'linkedin',
  TIKTOK: 'tiktok',
  SOCIAL_MEDIA: 'socialMedia',
};

export const SUBSCRIPTION_TYPES = {
  BRAND_PREMIER: 'Brand Premier',
  BRAND_STANDARD: 'Brand Standard',
  GROUP_PLUS: 'Group Plus',
  GROUP_STANDARD: 'Group Standard',
  AGENCY_STANDARD: 'Agency Standard',
  AGENCY_PLUS: 'Agency Plus',
  TALENT_STANDARD: 'Talent Standard',
  TALENT_PLUS: 'Talent Plus',
};

const BASE_GUIDE_PATH = `${BASE_AWS_URL}/talent-guides`;

const guideFileMap = {
  '1_ON_1_COACHING': '1-on-1Coaching.pdf',
  ATHLETE_BRANDING_CONSULTATION: 'AthleteBrandingConsultation.pdf',
  AUDIO_RECORDING: 'AudioRecording.pdf',
  AUTOGRAPHS: 'Autographs.pdf',
  AUTOGRAPH_SESSION: 'AutographSession.pdf',
  BEHIND_THE_SCENES_VIDEO: 'Behind-The-ScenesVideo.pdf',
  BUSINESS_PANEL: 'BusinessPanel.pdf',
  CAMP_PARTICIPATION: 'CampParticipation.pdf',
  CAREER_DEVELOPMENT_MENTORSHIP: 'CareerDevelopmentMentorship.pdf',
  CORPORATE_EVENT: 'CorporateEvent.pdf',
  CUSTOM_ARTICLES: 'CustomArticles.pdf',
  DIGITAL_INTERVIEW: 'DigitalInterview.pdf',
  E_SPORTS_APPEARANCE: 'E-SportsAppearance.pdf',
  FACEBOOK: 'Facebook.pdf',
  FILM_BREAKDOWN_SESSION: 'FilmBreakdownSession.pdf',
  FITNESS_DEMONSTRATION_VIDEO: 'FitnessDemonstrationVideo.pdf',
  FUNDRAISING_EVENT: 'FundraisingEvent.pdf',
  GAME_APPEARANCE: 'GameAppearance.pdf',
  GOLF_OUTING: 'GolfOuting.pdf',
  GROUP_TRAINING: 'GroupTraining.pdf',
  HALFTIME_APPEARANCE: 'HalftimeAppearance.pdf',
  HOW_TO_VIDEO: 'How-ToVideo.pdf',
  IN_PERSON_INTERVIEW: 'In-PersonInterview.pdf',
  INSTAGRAM: 'Instagram.pdf',
  LINKEDIN: 'LinkedIn.pdf',
  MEDIA_DAY_APPEARANCE: 'MediaDayAppearance.pdf',
  MEET_AND_GREET: 'MeetandGreet.pdf',
  MENTAL_TOUGHNESS_COACHING: 'MentalToughnessCoaching.pdf',
  MENTORSHIP_DISCUSSIONS: 'MentorshipDiscussions.pdf',
  META_THREADS_POST: 'MetaThreadsPost.pdf',
  NETWORKING_SESSIONS: 'NetworkingSessions.pdf',
  PHOTO_CREATION: 'PhotoCreation.pdf',
  PINTEREST_PIN: 'PinterestPin.pdf',
  PODCAST_APPEARANCE: 'PodcastAppearance.pdf',
  PODCAST_CLIP: 'PodcastClip.pdf',
  PRACTICE_APPEARANCE: 'PracticeAppearance.pdf',
  PRODUCTION_SHOOT: 'ProductionShoot.pdf',
  PRODUCT_TESTING_VIDEO: 'ProductTestingVideo.pdf',
  SHOUTOUTS_OR_GREETINGS: 'ShoutoutsorGreetings.pdf',
  SKILL_DEMONSTRATION: 'SkillDemonstration.pdf',
  SKILL_DEVELOPMENT: 'SkillDevelopment.pdf',
  SNAPCHAT: 'Snapchat.pdf',
  SPEECH: 'Speech.pdf',
  SPONSORSHIP_CONSULTATION: 'SponsorshipConsultation.pdf',
  TIKTOK: 'TikTok.pdf',
  TWITTER: 'Twitter(X).pdf',
  UNBOXING_VIDEO: 'UnboxingVideo.pdf',
  VIDEO_CREATION_WITH_AUDIO: 'VideoCreationwithAudio.pdf',
  VIRTUAL_CLASSROOM_VISIT: 'VirtualClassroomVisit.pdf',
  VIRTUAL_TRAINING_CAMP: 'VirtualTrainingCamp.pdf',
  VOICEOVER_RECORDING: 'VoiceoverRecording.pdf',
  WATCH_PARTY: 'WatchParty.pdf',
  YOUTUBE: 'YouTube.pdf',
  UNLOCKABLE_CONTENT: 'UnlockableContent.pdf',
};

export const TALENT_SERVICES_GUIDES = Object.entries(guideFileMap).reduce(
  (acc, [key, fileName]) => {
    acc[key] = `${BASE_GUIDE_PATH}/${fileName}`;
    return acc;
  },
  {}
);

export const StatusCode = {
  SUCCESS: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
  TOO_MANY_REQUESTS: 429,
};

export const SubscriptionPlanName = {
  BASIC: 'Basic',
  PREMIUM: 'Premium',

  //Talent
  TALENT_STANDARD: 'talent_standard',
  TALENT_PLUS: 'talent_plus',

  //Brands
  NIL_JOB_POSTING: 'nil_job_posting',
  NIL_DIY: 'nil_diy',
  NIL_ASSIST: 'nil_assist',
  NIL_COMPLETE: 'nil_complete',
  NIL_PREMIER: 'nil_premier',
  BRAND_STANDARD: 'brand_standard',
  BRAND_PREMIER: 'brand_premier',

  //School
  SCHOOL_STANDARD: 'school_standard',
  SCHOOL_PLUS: 'school_plus',

  //Agency
  AGENCY_STANDARD: 'agency_standard',
  AGENCY_PLUS: 'agency_plus',
};
export const SubscriptionStatus = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
};

export const MediaFieldName = Object.freeze({
  PROFILE_VIDEOS: 'profileVideos',
  LOGO: 'logo',
  PICTURES: 'pictures',
});

export const EditListingTab = Object.freeze({
  DETAILS: 'details',
  AVAILABILITY: 'availability',
  LINKS: 'links',
  SIGNATURE_SERVICES: 'signature-services',
  ENHANCED_SERVICES: 'enhanced-services',
  TALENT_PLUS_SERVICES: 'talent-plus-services',
  TALENT_PLUS_SERVICES: 'talent-plus-services',
  BRAND_PREMIER_SERVICES: 'brand-premier-services',
  GROUP_PLUS_SERVICES: 'group-plus-services',
});

export const LinkType = Object.freeze({
  INTERNAL: 'internal',
  EXTERNAL: 'external',
  STATIC: 'static',
});

export const PhotoTag = Object.freeze({
  PROFILE: 'profile',
  TRADING_CARD: 'tradingCard',
});

export const SUBSCRIPTION_LOOKUP_BY_USETYPE = {
  [UserType.TALENT]: ['talent', 'talent_plus'],
  [UserType.BRAND]: ['brand_standard', 'brand_premier'],
  [UserType.SCHOOL]: ['school_standard', 'school_plus'],
  [UserType.AGENCY]: ['agency', 'agency_plus'],
};

export const FieldKeys = Object.freeze({
  CURRENT_TOWN: 'pub_current_town',
  HOMETOWN: 'pub_hometown',
  SCHOOL_OR_TEAM: 'pub_school_or_team',
  AGENCY: 'pub_agency',
  STATE: 'pub_state',
  INTEREST: 'pub_interest',
  COMPANY: 'pub_company',
  SPORT: 'pub_sports',
});

export const LocationSectionFields = Object.freeze([
  FieldKeys.CURRENT_TOWN,
  FieldKeys.HOMETOWN,
  FieldKeys.SCHOOL_OR_TEAM,
  FieldKeys.AGENCY,
]);

export const AffiliationSectionFields = Object.freeze(
  Object.values(FieldKeys).filter(
    key => !LocationSectionFields.includes(key) && key !== FieldKeys.STATE
  )
);

export const ShoutoutOption = Object.freeze({
  HOLIDAY_SHOUTOUT: 'Holiday Shoutout',
});

export const SendgridEmailTemplate = Object.freeze({
  AGENCY_PLUS: 'ID',
  JOB_INVITE: 'JOB_INVITE',
});

export const InputType = Object.freeze({
  CHECKBOX: 'checkbox',
  RADIO: 'radio',
  NUMBER: 'number',
  TEXT: 'text',
});

export const Direction = Object.freeze({
  TOP: 'top',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  LEFT: 'left',
});

export const BOOLEAN_STRINGS = Object.freeze({
  TRUE: 'true',
  FALSE: 'false',
});
export const TRANSACTION_PROCESS_ALIAS = Object.freeze({
  DEFAULT_PURCHASE: 'default-purchase/release-1',
  DEFAULT_INQUIRY: 'default-inquiry/release-1',
  DEFAULT_BOOKING: 'default-booking/release-1',
});

export const UNIT_TYPE = Object.freeze({
  ITEM: 'item',
  DAY: 'day',
  NIGHT: 'night',
  HOUR: 'hour',
  INQUIRY: 'inquiry',
});

export const ListingType = Object.freeze({
  PURCHASE: 'purchase',
  BOOKING: 'booking',
});

export const TalentPlusService = Object.freeze({
  EXCLUSIVE_TRAINING: 'Exclusive Training',
  MENTORSHIP: 'Mentorship',
  BUSINESS_DEVELOPMENT: 'Business Development',
  CONTENT_CREATION: 'Content Creation',
  SOCIAL_MEDIA: 'Social Media',
  CUSTOM_SERVICE: 'Custom Service',
});

export const EditListingParamsType = Object.freeze({
  EDIT: 'edit',
  NEW: 'new',
  DRAFT: 'draft',
});

export const SectionHeroTabs = Object.freeze({
  ABOUT: 'Home',
  SIGNATURE_SERVICES: 'Signature Services',
  ENHANCED_SERVICES: 'Enhanced Services',
  TALENT_PLUS: 'Talent Plus',
  SUBCRIPTIONS: 'Subscribe',
  NILFLUENCE_SCORE: 'NILfluence Score',
  UNLOCKABLE_CONTENT: 'Unlockable Content',
  // BRAND_LINKS: 'Brand Links',
  // CAMPAIGN_SHOWCASE: 'Campaign Showcase',
  // POSTED_CONTENT: 'Posted Content',
  // TALENT_ROSTER: 'Talent Roster',
  // FAN_CHAT: 'Fan Chat',
  // LIVE_STREAMING: 'Live Streaming',
  // JOIN_A_1_ON_1_VIDEO_CALL: 'Join a 1-on-1 Video Call',
  // SOCIAL_MEDIA_FEEDS: 'Social Media Feeds',
});

export const SearchPageCategoryOption = Object.freeze({
  ALL: 'Talent',
  BRAND: 'Brand',
  AGENCY: 'agency',
  SCHOOL: 'school',
});

export const brandIndustriesOptions = [
  { label: 'Alternative Dispute Resolution', value: 'alternative-dispute-resolution' },
  { label: 'Alternative Medicine', value: 'alternative-medicine' },
  { label: 'Animation', value: 'animation' },
  { label: 'Architecture & Planning', value: 'architecture-planning' },
  { label: 'Arts and Crafts', value: 'arts-and-crafts' },
  { label: 'Automotive', value: 'automotive' },
  { label: 'Aviation & Aerospace', value: 'aviation-aerospace' },
  { label: 'Banking', value: 'banking' },
  { label: 'Biotechnology', value: 'biotechnology' },
  { label: 'Broadcast Media', value: 'broadcast-media' },
  { label: 'Building Materials', value: 'building-materials' },
  { label: 'Business Supplies and Equipment', value: 'business-supplies-equipment' },
  { label: 'Capital Markets', value: 'capital-markets' },
  { label: 'Chemicals', value: 'chemicals' },
  { label: 'Civic & Social Organization', value: 'civic-social-organization' },
  { label: 'Civil Engineering', value: 'civil-engineering' },
  { label: 'Commercial Real Estate', value: 'commercial-real-estate' },
  { label: 'Computer & Network Security', value: 'computer-network-security' },
  { label: 'Computer Games', value: 'computer-games' },
  { label: 'Computer Hardware', value: 'computer-hardware' },
  { label: 'Computer Networking', value: 'computer-networking' },
  { label: 'Computer Software', value: 'computer-software' },
  { label: 'Internet', value: 'internet' },
  { label: 'Construction', value: 'construction' },
  { label: 'Consumer Electronics', value: 'consumer-electronics' },
  { label: 'Consumer Goods', value: 'consumer-goods' },
  { label: 'Consumer Services', value: 'consumer-services' },
  { label: 'Cosmetics', value: 'cosmetics' },
  { label: 'Dairy', value: 'dairy' },
  { label: 'Defense & Space', value: 'defense-space' },
  { label: 'Design', value: 'design' },
  { label: 'Education Management', value: 'education-management' },
  { label: 'E-Learning', value: 'e-learning' },
  { label: 'Electrical/Electronic Manufacturing', value: 'electrical-electronic-manufacturing' },
  { label: 'Entertainment', value: 'entertainment' },
  { label: 'Environmental Services', value: 'environmental-services' },
  { label: 'Events Services', value: 'events-services' },
  { label: 'Executive Office', value: 'executive-office' },
  { label: 'Facilities Services', value: 'facilities-services' },
  { label: 'Farming', value: 'farming' },
  { label: 'Financial Services', value: 'financial-services' },
  { label: 'Fine Art', value: 'fine-art' },
  { label: 'Fishery', value: 'fishery' },
  { label: 'Food & Beverages', value: 'food-beverages' },
  { label: 'Food Production', value: 'food-production' },
  { label: 'Fund-Raising', value: 'fund-raising' },
  { label: 'Furniture', value: 'furniture' },
  { label: 'Gambling & Casinos', value: 'gambling-casinos' },
  { label: 'Glass, Ceramics & Concrete', value: 'glass-ceramics-concrete' },
  { label: 'Government Administration', value: 'government-administration' },
  { label: 'Government Relations', value: 'government-relations' },
  { label: 'Graphic Design', value: 'graphic-design' },
  { label: 'Health, Wellness and Fitness', value: 'health-wellness-fitness' },
  { label: 'Higher Education', value: 'higher-education' },
  { label: 'Hospital & Health Care', value: 'hospital-health-care' },
  { label: 'Hospitality', value: 'hospitality' },
  { label: 'Human Resources', value: 'human-resources' },
  { label: 'Import and Export', value: 'import-export' },
  { label: 'Individual & Family Services', value: 'individual-family-services' },
  { label: 'Industrial Automation', value: 'industrial-automation' },
  { label: 'Information Services', value: 'information-services' },
  { label: 'Information Technology and Services', value: 'information-technology-services' },
  { label: 'Insurance', value: 'insurance' },
  { label: 'International Affairs', value: 'international-affairs' },
  { label: 'International Trade and Development', value: 'international-trade-development' },
  { label: 'Investment Banking', value: 'investment-banking' },
  { label: 'Investment Management', value: 'investment-management' },
  { label: 'Judiciary', value: 'judiciary' },
  { label: 'Law Enforcement', value: 'law-enforcement' },
  { label: 'Law Practice', value: 'law-practice' },
  { label: 'Legal Services', value: 'legal-services' },
  { label: 'Legislative Office', value: 'legislative-office' },
  { label: 'Leisure, Travel & Tourism', value: 'leisure-travel-tourism' },
  { label: 'Libraries', value: 'libraries' },
  { label: 'Logistics and Supply Chain', value: 'logistics-supply-chain' },
  { label: 'Luxury Goods & Jewelry', value: 'luxury-goods-jewelry' },
  { label: 'Machinery', value: 'machinery' },
  { label: 'Management Consulting', value: 'management-consulting' },
  { label: 'Market Research', value: 'market-research' },
  { label: 'Agriculture Equipment', value: 'agriculture-equipment' },
  { label: 'Apartment Complex', value: 'apartment-complex' },
  { label: 'Apparel & Fashion', value: 'apparel-fashion' },
  { label: 'Auto Dealer', value: 'auto-dealer' },
  { label: 'Bedding', value: 'bedding' },
  { label: 'Beverage', value: 'beverage' },
  { label: 'Book Store', value: 'book-store' },
  { label: 'Broadcasting', value: 'broadcasting' },
  { label: 'Charity', value: 'charity' },
  { label: 'Clothing', value: 'clothing' },
  { label: 'Cryptocurrency', value: 'cryptocurrency' },
  { label: 'Electronics', value: 'electronics' },
  { label: 'Employee Benefits', value: 'employee-benefits' },
  { label: 'Fan Community', value: 'fan-community' },
  { label: 'Fencing', value: 'fencing' },
  { label: 'Food', value: 'food' },
  { label: 'Food Delivery', value: 'food-delivery' },
  { label: 'Gaming', value: 'gaming' },
  { label: 'Grocery', value: 'grocery' },
  { label: 'HVAC', value: 'hvac' },
  { label: 'Internet Service Provider', value: 'internet-service-provider' },
  { label: 'Investment', value: 'investment' },
  { label: 'Lawncare', value: 'lawncare' },
  { label: 'Local Advisor', value: 'local-advisor' },
  { label: 'Manufacturer', value: 'manufacturer' },
  { label: 'Marketing and Advertising', value: 'marketing-advertising' },
  { label: 'Mattress', value: 'mattress' },
  { label: 'Mechanical or Industrial Engineering', value: 'mechanical-industrial-engineering' },
  { label: 'Media Production', value: 'media-production' },
  { label: 'Medical Devices', value: 'medical-devices' },
  { label: 'Medical Practice', value: 'medical-practice' },
  { label: 'Memorabilia', value: 'memorabilia' },
  { label: 'Mental Health Care', value: 'mental-health-care' },
  { label: 'Military', value: 'military' },
  { label: 'Mining & Metals', value: 'mining-metals' },
  { label: 'Motion Pictures and Film', value: 'motion-pictures-film' },
  { label: 'Museums and Institutions', value: 'museums-institutions' },
  { label: 'Music', value: 'music' },
  { label: 'Nanotechnology', value: 'nanotechnology' },
  { label: 'Newspapers', value: 'newspapers' },
  { label: 'NIL', value: 'nil' },
  { label: 'Non-Profit Organization Management', value: 'non-profit-organization-management' },
  { label: 'Oil & Energy', value: 'oil-energy' },
  { label: 'Online Media', value: 'online-media' },
  { label: 'Outdoor Equipment', value: 'outdoor-equipment' },
  { label: 'Outsourcing/Offshoring', value: 'outsourcing-offshoring' },
  { label: 'Package/Freight Delivery', value: 'package-freight-delivery' },
  { label: 'Packaging and Containers', value: 'packaging-containers' },
  { label: 'Paper & Forest Products', value: 'paper-forest-products' },
  { label: 'Performing Arts', value: 'performing-arts' },
  { label: 'Personal Care', value: 'personal-care' },
  { label: 'Pharmaceuticals', value: 'pharmaceuticals' },
  { label: 'Philanthropy', value: 'philanthropy' },
  { label: 'Photography', value: 'photography' },
  { label: 'Plastics', value: 'plastics' },
  { label: 'Political Organization', value: 'political-organization' },
  { label: 'Primary/Secondary Education', value: 'primary-secondary-education' },
  { label: 'Printing', value: 'printing' },
  { label: 'Professional Training & Coaching', value: 'professional-training-coaching' },
  { label: 'Program Development', value: 'program-development' },
  { label: 'Public Policy', value: 'public-policy' },
  { label: 'Public Relations and Communications', value: 'public-relations-communications' },
  { label: 'Public Safety', value: 'public-safety' },
  { label: 'Publishing', value: 'publishing' },
  { label: 'Railroad Manufacture', value: 'railroad-manufacture' },
  { label: 'Ranching', value: 'ranching' },
  { label: 'Real Estate', value: 'real-estate' },
  { label: 'Recreational Facilities and Services', value: 'recreational-facilities-services' },
  { label: 'Religious Institutions', value: 'religious-institutions' },
  { label: 'Renewables & Environment', value: 'renewables-environment' },
  { label: 'Rental Car', value: 'rental-car' },
  { label: 'Research', value: 'research' },
  { label: 'Restaurant', value: 'restaurant' },
  { label: 'Restaurants', value: 'restaurants' },
  { label: 'Retail', value: 'retail' },
  { label: 'Roofing', value: 'roofing' },
  { label: 'Security and Investigations', value: 'security-investigations' },
  { label: 'Semiconductors', value: 'semiconductors' },
  { label: 'Shipbuilding', value: 'shipbuilding' },
  { label: 'Sporting Goods', value: 'sporting-goods' },
  { label: 'Sports', value: 'sports' },
  { label: 'Sports Apparel', value: 'sports-apparel' },
  { label: 'Sports Camp', value: 'sports-camp' },
  { label: 'Sports Team', value: 'sports-team' },
  { label: 'Staffing and Recruiting', value: 'staffing-recruiting' },
  { label: 'Supermarkets', value: 'supermarkets' },
  { label: 'Telecommunications', value: 'telecommunications' },
  { label: 'Textiles', value: 'textiles' },
  { label: 'Think Tanks', value: 'think-tanks' },
  { label: 'Tickets', value: 'tickets' },
  { label: 'Tobacco', value: 'tobacco' },
  { label: 'Translation and Localization', value: 'translation-localization' },
  { label: 'Transportation/Trucking/Railroad', value: 'transportation-trucking-railroad' },
  { label: 'Utilities', value: 'utilities' },
  { label: 'Venture Capital & Private Equity', value: 'venture-capital-private-equity' },
  { label: 'Veterinary', value: 'veterinary' },
  { label: 'Warehousing', value: 'warehousing' },
  { label: 'Wholesale', value: 'wholesale' },
  { label: 'Windows', value: 'windows' },
  { label: 'Wine and Spirits', value: 'wine-spirits' },
  { label: 'Wireless', value: 'wireless' },
  { label: 'Writing and Editing', value: 'writing-editing' },
];

export const CAMPAIGN_UNITS = [
  { value: 'days', label: 'Days' },
  { value: 'weeks', label: 'Weeks' },
  { value: 'months', label: 'Months' },
  { value: 'years', label: 'Years' },
];

export const AGE_RANGES = [
  { value: '0-20', label: '0-20' },
  { value: '21-30', label: '21-30' },
  { value: '31-40', label: '31-40' },
  { value: '41-50', label: '41-50' },
  { value: '51-60', label: '51-60' },
  { value: '61-70', label: '61-70' },
  { value: '70+', label: '70+' },
];

export const JOB_OBJECTIVES = [
  { value: 'brandAwareness', label: 'Brand Awareness and Exposure' },
  { value: 'salesConversions', label: 'Sales and Direct Conversions' },
  { value: 'socialMediaGrowth', label: 'Social Media Growth and Engagement' },
  { value: 'brandCredibility', label: 'Brand Credibility and Authority' },
  { value: 'marketExpansion', label: 'Market Expansion and New Audiences' },
  { value: 'communityImpact', label: 'Community and Social Impact' },
  { value: 'productPlacement', label: 'Product Placement and Brand Integration' },
  { value: 'eventPromotion', label: 'Event Promotion and Appearances' },
  { value: 'ambassadorPartnerships', label: 'Long-Term Ambassador Partnerships' },
  { value: 'leadGeneration', label: 'Lead Generation and Customer Acquisition' },
];

export const topbarNavSubMenu = [
  // {
  //   label: 'TopbarDesktop.thePathway',
  //   subMenu: [
  //     {
  //       label: 'TopbarDesktop.theTalentJourney',
  //       type: 'internal',
  //       href: 'CMSPage',
  //       params: { pageId: 'for-talent' },
  //     },
  //     {
  //       label: 'TopbarDesktop.theBrandJourney',
  //       type: 'internal',
  //       href: 'CMSPage',
  //       params: { pageId: 'for-brands' },
  //     },
  //     {
  //       label: 'TopbarDesktop.theSchoolCollectiveTeamJourney',
  //       type: 'internal',
  //       href: 'CMSPage',
  //       params: { pageId: 'for-groups' },
  //     },
  //     {
  //       label: 'TopbarDesktop.theFanJourney',
  //       type: 'internal',
  //       href: 'CMSPage',
  //       params: { pageId: 'for-fans' },
  //     },
  //     {
  //       label: 'TopbarDesktop.theAgencyJourney',
  //       type: 'internal',
  //       href: 'CMSPage',
  //       params: { pageId: 'for-agencies' },
  //     },
  //   ],
  // },
  // {
  //   label: 'TopbarDesktop.edgeZone',
  //   subMenu: [
  //     {
  //       label: 'TopbarDesktop.talent',
  //       type: 'internal',
  //       href: 'CMSPage',
  //       params: { pageId: 'talent-edge-zone' },
  //       // subSubMenu: [
  //       //   {
  //       //     label: 'TopbarDesktop.academy',
  //       //     type: 'external',
  //       //     href: 'https://academy.prepfornil.com',
  //       //   },
  //       //   { label: 'TopbarDesktop.nilStores', type: 'external', href: 'http://nilstores.com' },
  //       //   {
  //       //     label: 'TopbarDesktop.promosForNIL',
  //       //     type: 'external',
  //       //     href: 'http://www.promosfornil.com',
  //       //   },
  //       // ],
  //     },
  //     {
  //       label: 'TopbarDesktop.agenciesText',
  //       type: 'internal',
  //       href: 'CMSPage',
  //       params: { pageId: 'agency-edge-zone' },
  //     },
  //     {
  //       label: 'TopbarDesktop.brands',
  //       type: 'internal',
  //       href: 'CMSPage',
  //       params: { pageId: 'brand-edge-zone' },
  //     },
  //     {
  //       label: 'TopbarDesktop.groups',
  //       type: 'internal',
  //       href: 'CMSPage',
  //       params: { pageId: 'group-edge-zone' },
  //     },
  //   ],
  // },
  {
    label: 'TopbarDesktop.about',
    subMenu: [
      {
        label: 'TopbarDesktop.aboutUs',
        type: 'internal',
        href: 'CMSPage',
        params: { pageId: 'about-us' },
      },
      {
        label: 'TopbarDesktop.missionValue',
        type: 'internal',
        href: 'CMSPage',
        params: { pageId: 'mission-values' },
      },
    ],
  },
];

export const CUSTOM = 'custom';

export const ListingCategory = Object.freeze({
  BRAND_PERKS: 'brandperks',
  BRAND_JOB_POST: 'brandjobPost',
});

export const FormFieldName = {
  EMAIL: 'email',
  PHONE_NUMBER: 'phoneNumber',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  DESCRIPTION: 'description',
};

export const PARAM_KEYS = {
  talentType: 'pub_pub_talent_type',
  sport: 'pub_pub_sport',
  agency: 'pub_agency_name',
  division: 'pub_division',
  school: 'pub_school',
  sports: 'pub_pub_sports',
  conference: 'pub_conference',
  currentCity: 'pub_currentCity',
  homeTownCity: 'pub_homeTownCity',
  age: 'pub_age',
  followers: 'pub_totalFollowers',
  ethnicity: 'pub_pub_ethnicity',
  talentLevel: 'pub_pub_talent_level',
  gender: 'pub_pub_gender',
  interests: 'pub_pub_interest',
  primaryIndustry: 'pub_pub_primary_industry',
  ListingCategory: 'pub_listingCategory',
  groupType: 'pub_pub_user_type_sct',
  subscriptionType: 'pub_subscriptionType',
  streetAddress: 'pub_addressLine2',
  state: 'pub_state',
  KEYWORDS: 'keywords',
  customInterests: 'pub_customInterests',
  price: 'price',
  SOCIAL_MEDIA_PLATFORM: 'pub_socialMediaPlatform',
  DELIVERY_METHOD: 'pub_deliveryMethod',
  AVAILABILITY: 'pub_availability',
  CRITERIA: 'pub_criteria',
  JOB_OBJECTIVE: 'pub_jobObjective',
  AGE_RANGE: 'pub_ageRange',
  OPPORTUNITIES: 'pub_opportunities',
  PUB_HOMETOWN_STATE: 'pub_hometownState',
  PUB_IS_APPEARANCE: 'pub_isAppearance',
  PUB_IS_AUTOGRAPH: 'pub_isAutograph',
  PUB_IS_CREATIVE_MEDIA: 'pub_isCreativeMedia',
  PUB_IS_ENDORSED: 'pub_isEndorsed',
  PUB_IS_ENHANCED_SERVICES: 'pub_isEnhancedServices',
  PUB_IS_SHOUTOUT: 'pub_isShoutout',
  PUB_IS_TALENT_PLUS_SERVICES: 'pub_isTalentPlusServices',
  PUB_SHOUTOUTS_SUB_TYPES: 'pub_shoutoutsSubTypes',
  PUB_ENHANCED_SERVICES_SUB_TYPES: 'pub_enhancedServicesSubTypes',
  PUB_ENDORSEMENTS_SUB_TYPES: 'pub_endorsementsSubTypes',
  PUB_CREATIVE_MEDIA_SUB_TYPES: 'pub_creativeMediaSubTypes',
  PUB_AUTOGRAPHS_SUB_TYPES: 'pub_autographsSubTypes',
  PUB_APPEARANCES_SUB_TYPES: 'pub_appearancesSubTypes',
  PUB_UNLOCKABLE_PHOTOS: 'pub_unlockablePhotos',
  PUB_UNLOCKABLE_POSTS: 'pub_unlockablePosts',
  PUB_UNLOCKABLE_VIDEOS: 'pub_unlockableVideos',
  PUB_IS_EXCLUSIVE_TRAINING: 'pub_isExclusiveTraining',
  PUB_IS_BUSINESS_DEVELOPMENT: 'pub_isBusinessDevelopment',
  PUB_IS_UNLOCKABLE_CONTENT: 'pub_isUnlockableContent',
  PUB_IS_MENTORSHIP: 'pub_isMentorship',
  PUB_UNLOCKABLE_TYPES: 'pub_unlockableTypes',
  PUB_AUCTIONS: 'pub_auctions',
};

// Mapping keys to display labels
export const filterTalentSidebarSectionLabels = {
  talentType: 'Type of Talent',
  talentLevel: 'Talent Level',
  sports: 'Sport or Activity',
  school: 'School',
  division: 'Division',
  conference: 'Conference',
  service: 'Service',
  agency: 'Agency',
  followers: 'Followers',
  age: 'Age',
  gender: 'Gender',
  ethnicity: 'Ethnicity',
  interests: 'Interests',
  customInterests: 'Custom Interests',
  currentLocation: 'Hometown & Current Location Search',
  hometown: 'Hometown & Current State Search',
  opportunities: 'Your NIL Opportunities',
};

export const filterBrandSidebarSectionLabels = {
  industry: 'Industry',
  location: 'Location',
  brandPremier: 'Brand Premier',
  brandStandard: 'Brand Standard',
  opportunities: 'Opportunities',
};
export const filterGroupSidebarSectionLabels = {
  location: 'Location',
  division: 'Division',
  conference: 'Conference',
  groupType: 'Group Type',
  groupPlus: 'Group Plus',
  groupStandard: 'Group Standard',
  // subscriptionLevel: 'Subscription Level',
  opportunities: 'Opportunities',
};
export const filterAgencySidebarSectionLabels = {
  location: 'Location',
  opportunities: 'Opportunities',
};

export const UploadStatus = Object.freeze({
  UPLOADING: 'uploading',
  DONE: 'done',
  ERROR: 'error',
});

export const UnlockableContentFields = Object.freeze({
  PHOTOS: 'photos',
  VIDEOS: 'videos',
  POSTS: 'posts',
});
export const SectionUnlockableTab = Object.freeze({
  PHOTOS: 'Photos',
  VIDEOS: 'Videos',
  POSTS: 'Posts',
});

export const US_STATES = [
  { code: 'AL', name: 'Alabama' },
  { code: 'AK', name: 'Alaska' },
  { code: 'AZ', name: 'Arizona' },
  { code: 'AR', name: 'Arkansas' },
  { code: 'CA', name: 'California' },
  { code: 'CO', name: 'Colorado' },
  { code: 'CT', name: 'Connecticut' },
  { code: 'DE', name: 'Delaware' },
  { code: 'FL', name: 'Florida' },
  { code: 'GA', name: 'Georgia' },
  { code: 'HI', name: 'Hawaii' },
  { code: 'ID', name: 'Idaho' },
  { code: 'IL', name: 'Illinois' },
  { code: 'IN', name: 'Indiana' },
  { code: 'IA', name: 'Iowa' },
  { code: 'KS', name: 'Kansas' },
  { code: 'KY', name: 'Kentucky' },
  { code: 'LA', name: 'Louisiana' },
  { code: 'ME', name: 'Maine' },
  { code: 'MD', name: 'Maryland' },
  { code: 'MA', name: 'Massachusetts' },
  { code: 'MI', name: 'Michigan' },
  { code: 'MN', name: 'Minnesota' },
  { code: 'MS', name: 'Mississippi' },
  { code: 'MO', name: 'Missouri' },
  { code: 'MT', name: 'Montana' },
  { code: 'NE', name: 'Nebraska' },
  { code: 'NV', name: 'Nevada' },
  { code: 'NH', name: 'New Hampshire' },
  { code: 'NJ', name: 'New Jersey' },
  { code: 'NM', name: 'New Mexico' },
  { code: 'NY', name: 'New York' },
  { code: 'NC', name: 'North Carolina' },
  { code: 'ND', name: 'North Dakota' },
  { code: 'OH', name: 'Ohio' },
  { code: 'OK', name: 'Oklahoma' },
  { code: 'OR', name: 'Oregon' },
  { code: 'PA', name: 'Pennsylvania' },
  { code: 'RI', name: 'Rhode Island' },
  { code: 'SC', name: 'South Carolina' },
  { code: 'SD', name: 'South Dakota' },
  { code: 'TN', name: 'Tennessee' },
  { code: 'TX', name: 'Texas' },
  { code: 'UT', name: 'Utah' },
  { code: 'VT', name: 'Vermont' },
  { code: 'VA', name: 'Virginia' },
  { code: 'WA', name: 'Washington' },
  { code: 'WV', name: 'West Virginia' },
  { code: 'WI', name: 'Wisconsin' },
  { code: 'WY', name: 'Wyoming' },
];

export const sportsAndTeamOptions = [
  { sport: 'Baseball', team: 'Baltimore Orioles' },
  { sport: 'Baseball', team: 'Boston Red Sox' },
  { sport: 'Baseball', team: 'New York Yankees' },
  { sport: 'Baseball', team: 'Tampa Bay Rays' },
  { sport: 'Baseball', team: 'Toronto Blue Jays' },
  { sport: 'Baseball', team: 'Chicago White Sox' },
  { sport: 'Baseball', team: 'Cleveland Guardians' },
  { sport: 'Baseball', team: 'Detroit Tigers' },
  { sport: 'Baseball', team: 'Kansas City Royals' },
  { sport: 'Baseball', team: 'Minnesota Twins' },
  { sport: 'Baseball', team: 'Houston Astros' },
  { sport: 'Baseball', team: 'Los Angeles Angels' },
  { sport: 'Baseball', team: 'Oakland Athletics' },
  { sport: 'Baseball', team: 'Seattle Mariners' },
  { sport: 'Baseball', team: 'Texas Rangers' },
  { sport: 'Baseball', team: 'Atlanta Braves' },
  { sport: 'Baseball', team: 'Miami Marlins' },
  { sport: 'Baseball', team: 'New York Mets' },
  { sport: 'Baseball', team: 'Philadelphia Phillies' },
  { sport: 'Baseball', team: 'Washington Nationals' },
  { sport: 'Baseball', team: 'Chicago Cubs' },
  { sport: 'Baseball', team: 'Cincinnati Reds' },
  { sport: 'Baseball', team: 'Milwaukee Brewers' },
  { sport: 'Baseball', team: 'Pittsburgh Pirates' },
  { sport: 'Baseball', team: 'St. Louis Cardinals' },
  { sport: 'Baseball', team: 'Arizona Diamondbacks' },
  { sport: 'Baseball', team: 'Colorado Rockies' },
  { sport: 'Baseball', team: 'Los Angeles Dodgers' },
  { sport: 'Baseball', team: 'San Diego Padres' },
  { sport: 'Baseball', team: 'San Francisco Giants' },

  { sport: 'Basketball', team: 'Atlanta Hawks' },
  { sport: 'Basketball', team: 'Boston Celtics' },
  { sport: 'Basketball', team: 'Brooklyn Nets' },
  { sport: 'Basketball', team: 'Charlotte Hornets' },
  { sport: 'Basketball', team: 'Chicago Bulls' },
  { sport: 'Basketball', team: 'Cleveland Cavaliers' },
  { sport: 'Basketball', team: 'Dallas Mavericks' },
  { sport: 'Basketball', team: 'Denver Nuggets' },
  { sport: 'Basketball', team: 'Detroit Pistons' },
  { sport: 'Basketball', team: 'Golden State Warriors' },
  { sport: 'Basketball', team: 'Houston Rockets' },
  { sport: 'Basketball', team: 'Indiana Pacers' },
  { sport: 'Basketball', team: 'Los Angeles Clippers' },
  { sport: 'Basketball', team: 'Los Angeles Lakers' },
  { sport: 'Basketball', team: 'Memphis Grizzlies' },
  { sport: 'Basketball', team: 'Miami Heat' },
  { sport: 'Basketball', team: 'Milwaukee Bucks' },
  { sport: 'Basketball', team: 'Minnesota Timberwolves' },
  { sport: 'Basketball', team: 'New Orleans Pelicans' },
  { sport: 'Basketball', team: 'New York Knicks' },
  { sport: 'Basketball', team: 'Oklahoma City Thunder' },
  { sport: 'Basketball', team: 'Orlando Magic' },
  { sport: 'Basketball', team: 'Philadelphia 76ers' },
  { sport: 'Basketball', team: 'Phoenix Suns' },
  { sport: 'Basketball', team: 'Portland Trail Blazers' },
  { sport: 'Basketball', team: 'Sacramento Kings' },
  { sport: 'Basketball', team: 'San Antonio Spurs' },
  { sport: 'Basketball', team: 'Toronto Raptors' },
  { sport: 'Basketball', team: 'Utah Jazz' },
  { sport: 'Basketball', team: 'Washington Wizards' },

  { sport: 'Football', team: 'Arizona Cardinals' },
  { sport: 'Football', team: 'Atlanta Falcons' },
  { sport: 'Football', team: 'Baltimore Ravens' },
  { sport: 'Football', team: 'Buffalo Bills' },
  { sport: 'Football', team: 'Carolina Panthers' },
  { sport: 'Football', team: 'Chicago Bears' },
  { sport: 'Football', team: 'Cincinnati Bengals' },
  { sport: 'Football', team: 'Cleveland Browns' },
  { sport: 'Football', team: 'Dallas Cowboys' },
  { sport: 'Football', team: 'Denver Broncos' },
  { sport: 'Football', team: 'Detroit Lions' },
  { sport: 'Football', team: 'Green Bay Packers' },
  { sport: 'Football', team: 'Houston Texans' },
  { sport: 'Football', team: 'Indianapolis Colts' },
  { sport: 'Football', team: 'Jacksonville Jaguars' },
  { sport: 'Football', team: 'Kansas City Chiefs' },
  { sport: 'Football', team: 'Las Vegas Raiders' },
  { sport: 'Football', team: 'Los Angeles Chargers' },
  { sport: 'Football', team: 'Los Angeles Rams' },
  { sport: 'Football', team: 'Miami Dolphins' },
  { sport: 'Football', team: 'Minnesota Vikings' },
  { sport: 'Football', team: 'New England Patriots' },
  { sport: 'Football', team: 'New Orleans Saints' },
  { sport: 'Football', team: 'New York Giants' },
  { sport: 'Football', team: 'New York Jets' },
  { sport: 'Football', team: 'Philadelphia Eagles' },
  { sport: 'Football', team: 'Pittsburgh Steelers' },
  { sport: 'Football', team: 'San Francisco 49ers' },
  { sport: 'Football', team: 'Seattle Seahawks' },
  { sport: 'Football', team: 'Tampa Bay Buccaneers' },
  { sport: 'Football', team: 'Tennessee Titans' },
  { sport: 'Football', team: 'Washington Commanders' },

  { sport: 'Hockey', team: 'Anaheim Ducks' },
  { sport: 'Hockey', team: 'Arizona Coyotes' },
  { sport: 'Hockey', team: 'Boston Bruins' },
  { sport: 'Hockey', team: 'Buffalo Sabres' },
  { sport: 'Hockey', team: 'Calgary Flames' },
  { sport: 'Hockey', team: 'Carolina Hurricanes' },
  { sport: 'Hockey', team: 'Chicago Blackhawks' },
  { sport: 'Hockey', team: 'Colorado Avalanche' },
  { sport: 'Hockey', team: 'Columbus Blue Jackets' },
  { sport: 'Hockey', team: 'Dallas Stars' },
  { sport: 'Hockey', team: 'Detroit Red Wings' },
  { sport: 'Hockey', team: 'Edmonton Oilers' },
  { sport: 'Hockey', team: 'Florida Panthers' },
  { sport: 'Hockey', team: 'Los Angeles Kings' },
  { sport: 'Hockey', team: 'Minnesota Wild' },
  { sport: 'Hockey', team: 'Montreal Canadiens' },
  { sport: 'Hockey', team: 'Nashville Predators' },
  { sport: 'Hockey', team: 'New Jersey Devils' },
  { sport: 'Hockey', team: 'New York Islanders' },
  { sport: 'Hockey', team: 'New York Rangers' },
  { sport: 'Hockey', team: 'Ottawa Senators' },
  { sport: 'Hockey', team: 'Philadelphia Flyers' },
  { sport: 'Hockey', team: 'Pittsburgh Penguins' },
  { sport: 'Hockey', team: 'San Jose Sharks' },
  { sport: 'Hockey', team: 'Seattle Kraken' },
  { sport: 'Hockey', team: 'St. Louis Blues' },
  { sport: 'Hockey', team: 'Tampa Bay Lightning' },
  { sport: 'Hockey', team: 'Toronto Maple Leafs' },
  { sport: 'Hockey', team: 'Vancouver Canucks' },
  { sport: 'Hockey', team: 'Vegas Golden Knights' },
  { sport: 'Hockey', team: 'Washington Capitals' },
  { sport: 'Hockey', team: 'Winnipeg Jets' },

  { sport: 'Soccer', team: 'Atlanta United' },
  { sport: 'Soccer', team: 'Austin FC' },
  { sport: 'Soccer', team: 'Charlotte FC' },
  { sport: 'Soccer', team: 'Chicago Fire' },
  { sport: 'Soccer', team: 'FC Cincinnati' },
  { sport: 'Soccer', team: 'Colorado Rapids' },
  { sport: 'Soccer', team: 'Columbus Crew' },
  { sport: 'Soccer', team: 'D.C. United' },
  { sport: 'Soccer', team: 'FC Dallas' },
  { sport: 'Soccer', team: 'Houston Dynamo' },
  { sport: 'Soccer', team: 'Sporting Kansas City' },
  { sport: 'Soccer', team: 'LA Galaxy' },
  { sport: 'Soccer', team: 'Los Angeles FC' },
  { sport: 'Soccer', team: 'Inter Miami' },
  { sport: 'Soccer', team: 'Minnesota United' },
  { sport: 'Soccer', team: 'CF Montreal' },
  { sport: 'Soccer', team: 'Nashville SC' },
  { sport: 'Soccer', team: 'New England Revolution' },
  { sport: 'Soccer', team: 'New York City FC' },
  { sport: 'Soccer', team: 'New York Red Bulls' },
  { sport: 'Soccer', team: 'Orlando City' },
  { sport: 'Soccer', team: 'Philadelphia Union' },
  { sport: 'Soccer', team: 'Portland Timbers' },
  { sport: 'Soccer', team: 'Real Salt Lake' },
  { sport: 'Soccer', team: 'San Jose Earthquakes' },
  { sport: 'Soccer', team: 'Seattle Sounders' },
  { sport: 'Soccer', team: 'St. Louis City SC' },
  { sport: 'Soccer', team: 'Toronto FC' },
  { sport: 'Soccer', team: 'Vancouver Whitecaps' },
];

export const CouponAvailabilityOptions = Object.freeze({
  SPECIFIC_CRITERIA: 'specificCriteria',
  ANY_TALENT: 'anyTalent',
  ALL_USERS: 'allUsers',
});

export const ListingState = Object.freeze({
  PUBLISHED: 'published',
  DRAFT: 'draft',
});

export const TalentOfferingFilterTabs = Object.freeze({
  SIGNATURE_SERVICES: 'signatureServices',
  AUCTIONS: 'auctions',
  TALENT_PLUS: 'talentPlus',
  ENHANCED_SERVICES: 'enhancedServices',
});

export const SectionBrandHeroTabs = Object.freeze({
  HOME: 'Home',
  BRAND_LINKS: 'Brand Links',
  SOCIAL_MEDIA_FEEDS: 'Social Media Feeds',
  CAMPAIGN_SHOWCASE: 'Campaign Showcase',
  POSTED_CONTENT: 'Posted Content',
  SUBSCRIPTION: 'Subscription',
});

export const SectionGroupHeroTabs = Object.freeze({
  HOME: 'Home',
  GROUP_PLUS: 'Group Plus',
  SUBSCRIPTION: 'Subscription',
});

export const SectionGroupHeroSubTabs = Object.freeze({
  CUSTOM_LINKS: 'Custom Links',
  SOCIAL_MEDIA_FEEDS: 'Social Media Feeds',
  TALENT_ROSTER: 'Talent Roster',
  CAMPAIGN_SHOWCASE: 'Campaign Showcase',
  POSTED_CONTENT: 'Posted Content',
  FAN_CHAT: 'Fan Chat',
  LIVE_STREAMING: 'Live Streaming',
});

export const BrandOfferingFilterCategories = Object.freeze({
  CAMPAIGNS: 'campaign',
  PERKS: 'perks',
  BULK_JOBS: 'bulkJobPost',
  SINGLE_JOBS: 'singlejobPost',
  REWARDS: 'reward',
});

export const CampaignFilterSidebarFilters = Object.freeze({
  LOCATION: 'Location',
  CAMPAIGN_LENGTH: 'Campaign Length',
  SERVICE_LEVEL: 'Service Level',
  PRICE: 'Price',
});
export const PerksFilterSidebarFilters = Object.freeze({
  SOCIAL_MEDIA_PLATFORM: 'Social Media Platform',
  DELIVERY_METHOD: 'Delivery Method',
  AVAILABILITY: 'Availability',
});
export const RewardsFilterSidebarFilters = Object.freeze({
  AVAILABILITY: 'Availability',
  CRITERIA: 'Criteria',
});
export const JobFilterSidebarOptions = Object.freeze({
  AGE_RANGE: 'Age Range',
  AVAILABILITY: 'Availability',
  PRICE: 'Price',
  SOCIAL_MEDIA_PLATFORM: 'Social Media Platform',
  LOCATION: 'Location',
  JOB_OBJECTIVES: 'Job Objectives',
});

export const SubFiltersMap = Object.freeze({
  ['pub_isSignatureServices']: [
    { label: 'Autographs', value: 'pub_isAutograph' },
    { label: 'Shoutouts', value: 'pub_isShoutout' },
    { label: 'Endorsements', value: 'pub_isEndorsed' },
    { label: 'Appearances', value: 'pub_isAppearance' },
    { label: 'Creative Media', value: 'pub_isCreativeMedia' },
  ],
  ['pub_isEnhancedServices']: [
    { label: 'Exclusive Training', value: 'pub_isExclusiveTraining' },
    { label: 'Mentorship', value: 'pub_isMentorship' },
    { label: 'Business Development', value: 'pub_isBusinessDevelopment' },
  ],
  ['pub_isTalentPlusServices']: [
    { label: 'Group Training', value: 'Group Training' },
    { label: 'Skill Development', value: 'Skill Development' },
    { label: 'Corporate Event', value: 'Corporate Event' },
    { label: 'Exercise', value: 'Exercise' },
  ],
  ['pub_auctions']: [],
});

export const LinkTalentTabs = Object.freeze({
  LINK: 'link',
  VIEW: 'view',
});

export const SearchPageCategoryParams = Object.freeze({
  brand: [PARAM_KEYS.primaryIndustry, PARAM_KEYS.state, PARAM_KEYS.subscriptionType],
  school: [
    PARAM_KEYS.division,
    PARAM_KEYS.state,
    PARAM_KEYS.groupType,
    PARAM_KEYS.subscriptionType,
  ],
  talent: [
    PARAM_KEYS.talentType,
    PARAM_KEYS.talentLevel,
    PARAM_KEYS.sports,
    PARAM_KEYS.school,
    PARAM_KEYS.division,
    PARAM_KEYS.PUB_IS_APPEARANCE,
    PARAM_KEYS.PUB_IS_AUTOGRAPH,
    PARAM_KEYS.PUB_IS_CREATIVE_MEDIA,
    PARAM_KEYS.PUB_IS_ENDORSED,
    PARAM_KEYS.PUB_IS_ENHANCED_SERVICES,
    PARAM_KEYS.PUB_IS_SHOUTOUT,
    PARAM_KEYS.PUB_IS_EXCLUSIVE_TRAINING,
    PARAM_KEYS.PUB_IS_BUSINESS_DEVELOPMENT,
    PARAM_KEYS.PUB_IS_MENTORSHIP,
    PARAM_KEYS.PUB_IS_TALENT_PLUS_SERVICES,
    PARAM_KEYS.PUB_AUCTIONS,
    PARAM_KEYS.agency,
    PARAM_KEYS.followers,
    PARAM_KEYS.age,
    PARAM_KEYS.gender,
    PARAM_KEYS.ethnicity,
    PARAM_KEYS.interests,
    PARAM_KEYS.customInterests,
    PARAM_KEYS.PUB_HOMETOWN_STATE,
  ],
});

export const BulkUploadUsersPanel_fields = [
  'firstName',
  'lastName',
  'displayName',
  'email',
  'emailVerified',
  'state',
  'school',
];
export const BulkUploadUsersPanel_requiredFields = [
  'firstName',
  'lastName',
  'email',
  'displayName',
];

export const BulkUploadUsersPanel_TableHeaders = {
  FIRST_NAME: 'First Name',
  LAST_NAME: 'Last Name',
  DISPLAY_NAME: 'Display Name',
  EMAIL: 'Email',
};

export const PhylloStatus = Object.freeze({
  NOT_CONNECTED: 'NOT_CONNECTED',
});

export const ReferralStatus = Object.freeze({
  SIGNED_UP: 'signed_up',
  PURCHASED: 'purchased',
  INACTIVE: 'inactive',
});

export const SectionTalentHeroSliderSettings = Object.freeze({
  dots: true,
  arrows: false,
  infinite: false,
  autoplay: true,
  autoplaySpeed: 2200,
  speed: 500,
  cssEase: 'ease',
  slidesToShow: 2,
  slidesToScroll: 1,
  variableWidth: false,
  focusOnSelect: false,
  centerMode: false,
  responsive: [
    {
      breakpoint: 1128,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 580,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
});

export const FileExtension = Object.freeze({
  JPEG: 'jpeg',
  JPG: 'jpg',
  PNG: 'png',
});

export const Transitions = Object.freeze({
  INQUIRE: 'transition/inquire-without-payment',
  EXPIRE_PAYMENT_INTENT: 'transition/expire-payment-intent',
  CAPTURE_PAYMENT_INTENT: 'transition/capture-payment-intent',
});

export const ChatPurchaseModalSteps = Object.freeze({
  REVIEW: 'review',
  PAYMENT: 'payment',
});

export const RewardAvailability = Object.freeze({
  CERTAIN: 'certain',
  ALL_SPORTS: 'allSports',
  FANS: 'fans',
  ALL: 'all',
  ALL_USERS: 'allUsers',
});

export const PerksAvailability = Object.freeze({
  ALL_TALENT: 'allTalent',
});

export const JobsAvailability = Object.freeze({
  ANY_TALENT: 'anyTalent',
});

export const GroupSubscriptionContentType = Object.freeze({
  SUBSCRIPTION_BOX: 'subscriptionBox',
  CONTENT_SUBSCRIPTION: 'contentSubscription',
});

export const SignatureServiceTypes = Object.freeze({
  AUTOGRAPHS: 'autographs',
  APPEARANCES: 'appearances',
  SHOUTOUTS_OR_GREETINGS: 'shoutoutsOrGreetings',
  CREATIVE_MEDIA: 'creativeMedia',
  SOCIAL_MEDIA: 'socialMedia',
});

export const SocialMediaContentTypes = Object.freeze({
  POST: 'post',
  STORY: 'story',
  REEL: 'reel',
  SHORT: 'short',
  SPOTLIGHT: 'spotlight',
  LIVE: 'live',
  ARTICLE: 'article',
  RECOMMENDATION: 'recommendation',
  SCRIPT: 'script',
  APPEARANCE: 'appearance',
});

export const EnhancedServiceTypes = Object.freeze({
  EXCLUSIVE_TRAINING: 'exclusiveTraining',
  MENTORSHIP: 'mentorship',
  BUSINESS_DEVELOPMENT: 'businessDevelopment',
});

export const dateFormattingOptions = Object.freeze({
  month: 'short',
  day: 'numeric',
  weekday: 'short',
});

export const DeliveryMethod = Object.freeze({
  SHIPPING: 'shipping',
  PICKUP: 'pickup',
});

export const ListingDeliveryType = Object.freeze({
  DIGITAL_DELIVERY: 'digitalDelivery',
  PHYSICAL_ITEM: 'physicalItem',
  LIVE_SESSION: 'liveSession',
});

export const OrdersHeaderTabs = Object.freeze({
  BUYING: 'buying',
  SELLING: 'selling',
});

export const OrdersToggleView = Object.freeze({
  PROFILE: 'profile',
  ORDER: 'order',
});
